import React, { useState } from "react";
import { Button } from "react-bootstrap";
import axios from "axios";
import routes from "../../app/routes";
import pauseOffSwitcher from "images/icons/switch-on-orange.svg";
import pauseOnSwitcher from "images/icons/switch-member.svg";

export default function PauseButton({ className, state }) {
  const [isPause, setOnPause] = useState(state == "on");
  const [isBlockBtn, setBlockBtn] = useState(false);

  const changePauseState = (typeWork) => {
    let stringCurrentWork = isPause ? "on" : "off";
    if (!isBlockBtn && typeWork != stringCurrentWork) {
      let newPauseState = !isPause;
      setBlockBtn(true);

      axios.post(routes.api.coaches.pause).then((resp) => {
        setOnPause(resp.data.state == "on");
        setBlockBtn(false);
      });
    }
  };

  return (
    <div>
      {isPause && (
        <p className="orange">
          LeggUP doesn't include you in matching as your current status is
          paused. Turn off your pause status to start getting new members again.
        </p>
      )}

      {!isPause && (
        <p className="green">
          You can temporarily pause getting new members by clicking the Pause
          button. LeggUP will not include you in matching until you turn it off.
        </p>
      )}

      <div className={`text-center switch-role`}>
        <a
          onClick={() => changePauseState("off")}
          className={isPause ? "not-active" : "active"}
        >
          Pause Off
        </a>
        <img
          onClick={() => changePauseState("switch")}
          src={isPause ? pauseOffSwitcher : pauseOnSwitcher}
        />
        <a
          onClick={() => changePauseState("on")}
          className={isPause ? "active2" : "not-active"}
        >
          Pause On
        </a>
      </div>
    </div>
  );
}
